import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Column } from 'primereact/column'
import { Calendar } from 'primereact/calendar'
import { InputText } from 'primereact/inputtext'
import { routes } from '../../../constants'
import { Page } from '../../../components/page/Page'
import { AgendaList } from './AgendaList'
import { actions } from '../agenda.actions'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import { LoadingOverlay } from '../../../components/loadingSpinner/LoadingOverlay'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import utils from '../../../utils/index'
import storage from '../../../services/stoage.service'
import '../../../index.scss'

const mapStateToProps = (state) => {
  return {
    record: state.crudAgendaState.currentRecord,
    messages: state.crudAgendaState.messages,
    messagesDialog: storage.getAppLabels('dialogs'),
    showHideColumns: state.crudAgendaState.showHideColumns,
    columns: state.crudAgendaState.columns,
    records: state.crudAgendaState.records,
    isLoadingRecords: state.crudAgendaState.isLoadingRecords,
    first: state.crudAgendaState.index,
    rows: state.crudAgendaState.max,
    totalRecords: state.crudAgendaState.count,
    sortField: state.crudAgendaState.sortField,
    order: state.crudAgendaState.sortOrder,
    selectedFilters: state.crudAgendaState.selectedFilters,
    selectedRecords: state.crudAgendaState.selectedRecords,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    paginate: (paginationParams) => dispatch(actions.paginate(paginationParams)),
    sortOrder: (sortParams) => dispatch(actions.sortOrder(sortParams)),
    applyFilter: (filterParams) => {
      dispatch(actions.applyFilter(filterParams))
    },
    changeFilterCalendar: (campo, e) => {
      dispatch(actions.setSelectedFilters(campo.field, e.value, null, campo.field))
    },
    changeFilter: (column, e) => {
      const target = e.target
      let campo = column.fieldJoin ? column.fieldJoin : target.name
      dispatch(actions.setSelectedFilters(campo, target.value, column.relacionamento, column.field))
      setTimeout(() => {
        dispatch(actions.executeFilter(`/lottustech/agendas/all`))
      }, 400)
    },
    setSelectedRecords: (e) => {
      dispatch(actions.setSelectedRecords(e))
    },
    clearSelectedFilters: () => {
      dispatch(actions.clearSelectedFilters())
    },
    load: () => dispatch(actions.load()),
    setColumns: (columns) => dispatch(actions.loadColumns(columns)),
    changeHandler: (event) => {
      const target = event.target
      const field = target.name
      let valor = target.value
      dispatch(actions.removeErrors([{ field }]))
      dispatch(actions.setField(field, valor))
    },
    loadFavorito: (menu) => dispatch(actions.loadFavorito(menu)),
    removeFavorito: (menu) => dispatch(actions.removeFavorito(menu)),
    adicionarFavorito: (menu) => dispatch(actions.adicionarFavorito(menu)),
    exportarDadosCSV: () => dispatch(actions.exportCSV()),
    clearSelectedRecords: () => dispatch(actions.clearSelectedRecords()),
    getTemplateImportacao: () => {
      dispatch(actions.getTemplateImportacao())
    },
    uploadCsvImportacao: (arquivo) => {
      dispatch(actions.uploadCsvImportacao(arquivo))
    },
  }
}

class AgendaListPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.dataTableRef = React.createRef()
    this.messagesFilters = storage.getAppLabels('filtros')
    this.showHideColumns = []
    this.state = {
      dadosFavorito: null,
      favorito: 0,
    }

    this.onColumnToggle = this.onColumnToggle.bind(this)
  }
  //parametro com todas as colunas selecionadas atualmente
  onColumnToggle(event) {
    listPageUtils.onColumnToggle(event, this)
  }

  // MÉTODO CHAMADO AO REORDENAR AS COLUNAS
  onColReorder(e, colunasAtuais) {
    listPageUtils.onColumnReorder(e, colunasAtuais, this)
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  changeTipoFiltro = (filtro, valor) => {
    let filtroAtual = filtro
    filtroAtual.tipoFiltro = valor
    filtroAtual.dataFinal = null
    filtroAtual.mostrarDataInicial = valor.dataInicial
    filtroAtual.mostrarDataFinal = valor.dataFinal
    return filtroAtual
  }

  newHandler = () => {
    this.props.history.push(`${routes.PATH_AGENDA}/novo`)
  }
  componentDidMount() {
    listPageUtils.componentDidMount(this)
  }

  componentDidUpdate(prevProps, prevState) {
    listPageUtils.componentDidUpdate(this, prevProps, prevState)
  }

  componentWillUnmount() {
    this.props.clearSelectedRecords()
  }
  onPage = (e) => {
    listPageUtils.onPage(this, e)
  }

  onSort = (e) => {
    listPageUtils.onSort(this, e)
  }

  exportar(excel = true) {
    listPageUtils.onCsvExport(this.props.records, this, actions, excel)
  }

  onSelectionChange = (e) => {
    this.props.setSelectedRecords(e.value)
  }

  showFilters = () => {
    this.showFilter = !this.showFilter
  }

  buildHeader = () => {
    return (
      <DefaultToolBar
        listPageContainer={this}
        title={utils.getMessage(this.props.messages, 'agenda.label.agendamentos')}
      />
    )
  }

  oidTemplate = (rowData) => {
    return <Link to={`${routes.PATH_AGENDA}/${rowData.oid}`}>{rowData.oid}</Link>
  }

  pessoaTemplate = (rowData, column) => {
    if (rowData[column.field]) {
      let cpf = rowData[`${column.columnKey}_oid`]
      return <Link to={`${routes.PATH_PESSOA_FISICA}/${cpf}`}>{rowData[column.field]}</Link>
    }
  }

  formatColumn = (rowData, column) => {
    return utils.format(rowData, column)
  }

  fieldCalendarFilter = (column) => {
    let dataSelecionada = ''
    let filtro = utils.findObjectInArray(this.props.selectedFilters, 'campo', column.field)
    if (filtro && filtro.valor) {
      dataSelecionada = filtro.valor
    }
    return (
      <Calendar
        value={dataSelecionada}
        yearNavigator={true}
        monthNavigator={true}
        yearRange={utils.getYearRangeFromDate('1970')}
        appendTo={document.body}
        showButtonBar={true}
        onChange={(e) => this.props.changeFilter(column, e)}
        name={column.field}
      />
    )
  }
  fieldFilter = (column) => {
    return (
      <InputText
        style={{ width: '100%' }}
        name={column.field}
        value={this.props.selectedFilters[column.field]}
        onChange={(e) => this.props.changeFilter(column, e)}
      />
    )
  }
  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false

      if (col.field === 'multiselect') {
        return <Column selectionMode="multiple" style={{ width: '3em' }} />
      } else if (col.field === 'oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.oidTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-oid-body-width"
            filterHeaderClassName="column-oid-filter-header-width"
            headerClassName="column-oid-header-width"
          />
        )
      }
      if (col.field === 'dataInicial' || col.field === 'dataFinal') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.formatColumn}
            sortField={col.columnSortField}
            filterElement={this.fieldCalendarFilter(col)}
            bodyClassName="column-date-body-width"
            filterHeaderClassName="column-date-filter-header-width"
            headerClassName="column-date-header-width"
          />
        )
      }
      if (col.field === 'pessoa_nome') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.pessoaTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-nome-body-width"
            filterHeaderClassName="column-nome-filter-header-width"
            headerClassName="column-nome-header-width"
          />
        )
      }
      if (col.field === 'localizacao_identificacao') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.pessoaTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-localizacao-body-width"
            filterHeaderClassName="column-localizacao-filter-header-width"
            headerClassName="column-localizacao-header-width"
          />
        )
      }
      if (col.field === 'unidade_sigla') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.pessoaTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-unidade-body-width"
            filterHeaderClassName="column-unidade-filter-header-width"
            headerClassName="column-unidade-header-width"
          />
        )
      }
      if (col.field === 'observacao') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.pessoaTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-observacao-body-width"
            filterHeaderClassName="column-observacao-filter-header-width"
            headerClassName="column-observacao-header-width"
          />
        )
      }
      return <Column {...col} key={col.field} sortField={col.columnSortField} filterElement={this.fieldFilter(col)} />
    })
  }

  buildContent = () => {
    return (
      <div>
        <AgendaList
          {...this.props}
          onSelectionChange={this.onSelectionChange}
          dataTableRef={(el) => (this.dataTableRef = el)}
          onColReorder={(e) => this.onColReorder(e, this.showHideColumns)}
          onPage={this.onPage}
          onSort={this.onSort}
          columns={this.defineColumns()}
        />
      </div>
    )
  }
  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      // O LoadingSpinner abaixo so cobre a primeira montagem, quando ainda nao ha colunas. Depois
      // disso paginar/ordenar/filtrar refaz a consulta com a grade ja na tela, e sem o overlay a
      // espera nao tinha nenhum retorno visual.
      return (
        <React.Fragment>
          {this.props.isLoadingRecords && <LoadingOverlay />}
          <Page header={this.buildHeader()} content={this.buildContent()} />
        </React.Fragment>
      )
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AgendaListPageContainer)
